import { Image } from 'expo-image';
import { YStack } from 'tamagui';

import type { Membership } from '@/src/api/membershipsApi';
import { PassGlow, PlanBadge } from './MembershipPlanCard';
import PSText from './ui/PSText';

/** MembershipPlanCard's header alone — the plan being bought, not a pitch. */
export default function ConfirmationPagePlanCard({
  plan,
}: {
  plan: Membership;
}) {
  return (
    <YStack
      backgroundColor={'$color.brandDark'}
      alignSelf="stretch"
      borderRadius={'$radius.base'}
      overflow="hidden"
    >
      <PassGlow kind={plan.kind} />

      <YStack p={'$space.lg'} gap={'$space.md'}>
        <Image
          source={require('@/assets/images/access-pass-logo.png')}
          style={{ width: 144, height: 34 }}
          contentFit="contain"
        />
        <PSText.Body4 color={'$color.textWhiteMuted'}>
          {plan.description}
        </PSText.Body4>
      </YStack>

      <PlanBadge kind={plan.kind} />
    </YStack>
  );
}
